import { createUseStyles } from "react-jss";
import { breakpoints } from "../../../../constants/breakpoints";
import { colors } from "../../../../constants/colors"

const styles = createUseStyles(theme => ({
  receiptsTab: {
    marginTop: "32px",
    border: `1px solid ${colors.lightGrey}`,
    borderRadius: "12px"
  },
  title: {
    color: colors.lightBlack,
    fontSize: "18px",
    fontWeight: "600",
    lineHeight: "28px",
    marginBottom: 0
  },
  description: {
    color: colors.mediumGrey,
    fontSize: "14px",
    fontWeight: "400",
    lineHeight: "20px",
    marginBottom: 0
  },
  topContainer: {
    padding: "16px"
  },
  bottomContainer: {
    padding: "16px",
    display: "flex",
    [`@media (max-width: ${breakpoints.lg}px)`]: {
      flexDirection: "column"
    }
  },
  formContainer: {
    display: "flex",
    gap: "20px",
    [`@media (max-width: ${breakpoints.lg}px)`]: {
      marginBottom: "20px"
    },
    [`@media (max-width: ${breakpoints.sm}px)`]: {
      flexDirection: "column"
    }
  },
  label: {
    marginBottom: "8px",
    fontSize: "14px",
    fontWeight: "500",
    color: colors.grey
  },
  button: {
    position: "relative",
    display: "flex",
    borderRadius: "8px",
    textAlign: "center",
    textDecoration: "none",
    fontWeight: "600",
    fontSize: "16px",
    lineHeight: "20px",
    padding: "10px 18px",
    cursor: "pointer",
    userSelect: "none",
    height: "44px",
    marginLeft: "32px",
    alignSelf: "flex-end",
    alignItems: "center",
    [`@media (max-width: ${breakpoints.lg}px)`]: {
      marginLeft: 0,
      alignSelf: "flex-start",
    }
  },
  icon: {
    marginRight: "5px",
  },
  inputMonthContainer: {
    width: "250px",
    "& input":{
      height: "40px"
    },
    [`@media (max-width: ${breakpoints.lg}px)`]: {
      width: "100%"
    },
  },
  inputYearContainer: {
    width: "171px",
    "& input":{
      height: "40px"
    },
    [`@media (max-width: ${breakpoints.lg}px)`]: {
      width: "100%"
    },
  },
  downloadCsvLoadingState: {
    border: `${theme.buttons.disabled.border} !important`,
  }
}));

export default styles;
